<template>
  <el-select
    v-if="!readonly"
    :value="value"
    :disabled="disabled"
    :placeholder="placeholder"
    :clearable="clearable"
    :filterable="filterable"
    @input="handleInputVal"
    @change="$emit('change', $event)"
  >
    <el-option
      v-for="(item, key) in options"
      :disabled="item.disabled"
      :key="key"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
  <div v-else>
    {{ getLabel(value) }}
  </div>
</template>

<script>
import formMixin from './formMixin.js'
export default {
  mixins: [formMixin],
  components: {

  },
  props: ['options', 'filterable', 'readonly'],
  data() {
    return {}
  },
  methods: {
    handleInputVal(val) {
      this.$emit('input', val)
      this.$emit('change', val)
    },
    getLabel(val) {
      const options = this.options || []
      const selected = options.find(({ value }) => value === val)
      if (selected) {
        return selected.label
      }
    }
  },
  created() {

  }
}
</script>

<style lang="stylus" scoped>
</style>
